import styled from "styled-components"

import Heading from "./Heading"

const H2 = styled.h2`
  ${Heading}

  font-size: 32px;
`

export default H2
